import {AfterViewInit, Component} from '@angular/core';
import {ReserveAgreementNoneInsureFragmentController} from './ReserveAgreementNoneInsureFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {ReservationSaveDTOInterface} from '../../../../../../../DTO/ReservationSaveDTOInterface';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './ReserveAgreementNoneInsureFragmentComponent.html',
	styleUrls: ['../ReserveCreateFormLayout.scss', './ReserveAgreementNoneInsureFragmentComponent.scss'],
})
export class ReserveAgreementNoneInsureFragmentComponent extends BaseViewUI {

	// 紐付いたコントローラー
	public combineCtrl: ReserveAgreementNoneInsureFragmentController;

	public eventGotoNext: (reserve: ReservationSaveDTOInterface) => void;
	public eventSelectDate: () => void;
	// 同意
	public eventAgreeOnlineInsure: () => Promise<boolean>;
	public reserveModel: ReservationSaveDTOInterface = {} as ReservationSaveDTOInterface;

	public isUserLoggedIn = false;

	public isAgreement = false;
	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(ReserveAgreementNoneInsureFragmentController);

	}

	/**
	 * 開始処理
	 */
	public async start() {
		this.sendFingerprintLog('ReserveAgreementNoneInsureFragmentComponent', 'show');

		const yclid = sessionStorage.getItem('yclid');
		if (yclid) {
			history.pushState(null,null,'?yclid='+yclid);
		}
	}

	/**
	 * 同意
	 */
	public async onClickAgreement() {
		if (this.isAgreement === false) {
			await this.showAlertDialog('エラー', '規約に同意にチェックしてください');
			return;
		}

		this.sendFingerprintLog('ReserveAgreementNoneInsureFragmentComponent', 'onClickAgreement');

		const result = await this.eventAgreeOnlineInsure();
		await this.eventGotoNext(this.reserveModel);

	}

	/**
	 * 日時選択画面に戻る
	 */
	public async cancel() {

		this.sendFingerprintLog('ReserveAgreementNoneInsureFragmentComponent', 'cancel');

		await this.eventSelectDate();
	}

}

